// Crédito de desempenho por PESSOA (V5) — puro.
//
// O funil tem dois responsáveis: o SDR, que trabalha o lead até a consulta, e
// o negociador, que fecha (V4). O crédito segue o trabalho:
//   - leads trabalhados, agendamentos e comparecimentos → SDR ORIGINAL
//     (quem recebeu o lead; trocar de SDR depois não move o crédito);
//   - fechamentos e valor → NEGOCIADOR (sem negociador, o SDR original).
//
// `sdrOriginalId/Nome/Em` são gravados na PRIMEIRA atribuição e nunca mais
// (`leadsService`). Lead antigo sem o campo credita pelo `sdrId` atual.

import { temFuncao } from '@/equipe/funcoes';

// Sem importar `calculo.js` (que importa este módulo): cópia mínima do paraData.
const paraData = (v) => {
  if (!v) return null;
  if (typeof v.toDate === 'function') return v.toDate();
  if (v instanceof Date) return Number.isNaN(v.getTime()) ? null : v;
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
};

export const SEM_RESPONSAVEL = { id: '', nome: 'Sem responsável' };

/** Quem recebe o crédito de SDR: o original, senão o atual, senão ninguém. */
export function creditoSdr(lead) {
  if (lead?.sdrOriginalId) return { id: lead.sdrOriginalId, nome: lead.sdrOriginalNome || lead.sdrNome || '' };
  if (lead?.sdrId) return { id: lead.sdrId, nome: lead.sdrNome || '' };
  return SEM_RESPONSAVEL;
}

/** Quem recebe o crédito de fechamento: o negociador, senão o SDR (original). */
export function creditoNegociador(lead) {
  if (lead?.negociadorId) return { id: lead.negociadorId, nome: lead.negociadorNome || '' };
  return creditoSdr(lead);
}

/**
 * Quando o lead passou a ser "trabalhado" pelo SDR: a data da PRIMEIRA
 * atribuição. Lead do resgate nasce sem SDR e é distribuído depois — os 155 do
 * backfill são de agosto e serão distribuídos em setembro; a SDR recebe o lead
 * na atribuição, não na criação. Reserva: `criadoEm` (leads anteriores ao campo).
 */
export const dataTrabalhado = (lead) => paraData(lead?.sdrOriginalEm) ?? paraData(lead?.criadoEm);

/** Quem aparece no desempenho por pessoa: exerce função de venda (sdr ou negociador) — VP, uma regra só (`equipe/funcoes`). */
export const ehVendedor = (usuario) => temFuncao(usuario, 'sdr') || temFuncao(usuario, 'negociador');
